module.exports = __webpack_public_path__ + "static/img/ARROW.d031d84.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/overlay/ARROW.png
// module id = 512
// module chunks = 17